//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import IM, {
    IM_STORE,
    current_user_data
} from '@/data/im'

import { DEFAULT_HEADIMG } from '@/data/im/constant'

import Service from '@/service'
import ChatService from '@/service/chat'
import PublicService from '@/service/public'
import WX_API from '@/utils/wx_api'
import { App_User } from '@/data/user_info'
import { UserLog, errorLog } from '@/utils/log'

import { LEVEL_MAP } from '@/constant'

import Loading from '@/components/views/loading'
import MsgCard from './_msg_card'
import LocationMsg from './_location_msg'
import MsgSysTip from './_msg_sys_tip'
import MsgAsk from './_msg_ask'
import MsgBuildingCard from './_msg_building_card'
import AudioMsg from './_audio_msg'
import PeerUser from './_peer_user'
import ConsultantCard from './_consultant'
import FloatBuildingCard from './_float_building_card'
import ChatInput from './_chat_input'
import Tools from './_tools'
import Stickers from '../_base_components/_stickers'
import ClientMarkPicker from '@/components/views/_client_mark_picker'
import AuthPhone from '../_base_components/_auth_phone'
import BuildingPriceReport from '../_base_components_v/_building_price_report'

import Audio from './audio'

import aqr from '../_base_components/aqr'
import AqrBuilding from '../_base_components/_aqr_building'

import LayoutMsg from './_layout_msg.vue'

import { getMixin } from '@/common/tpl/im/im_login'

import ChatJoinGroupCard from '../_base_components/_chat_join_group_card'
import EvaluateDlg from '../_base_components/_evaluate_dlg'

import Evaluate from '../_base_components/evaluate'
import InviteCard from '../_base_components/_invite_card'
import Invite from '../_base_components/_invite'

import Expression from '../_base_components/_expression'
import expression from '../_base_components/expression'

import MsgTools from '../_base_components/_msg_tools'
import msg_tools from '../_base_components/msg_tools'


const KEY = 'CHAT'

const tasks = []

const status = {
    sending: false
}

let conversationId

export default {
    name: KEY,
    mixins: [
        aqr,
        getMixin({
            page_key: KEY
        }),
        msg_tools,
        expression,
        Evaluate
    ],
    data () {
        return {
            loading: true,
            no_more: false,
            show_msg: false,

            msgs: [],
            msg: '',

            chart_pos: 'msg-btm',

            is_consult: false,
            consultant: {},
            peer_persona: null,
            is_consultant_user: false,
            show_stickers: false,
            show_tools: false,
            show: false,
            show_picker: false,
            show_expression: false,
            enable_animation: false,
            peer_user: {
                client_name: '',
                client_mark: '',
                peer_headimgurl: '',
                peer_nickname: '',
                peer_ask_phone_status: '',
                client_description: '',
            },
            im_user: {
                nickname: '',
                headimgurl: ''
            },
            building: {
                consultant_count: 0
            },
            tim_session_id: '',
            show_building_card: false,

            auth_phone_number: false,
            is_block: false,
            is_peer_blocked: false,
            scroll_view_height: '',
            show_evaluate_dialog: false,
            user_loaded:false,
            target_is_consultant: false,
            rating: 1,
            consultant_id:'',
            invite_click: true,
            show_warning: false,
            show_bottom_wrap: true,
        }
    },
    created () {
        this.$watch(() => {
            return {
                show: this.show && this.show_msg,
                pos: this.chart_pos
            }
        }, ({ show, pos }) => {
            if (show) {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        document.getElementById(pos).scrollIntoView()
                    })
                })
            }
        })
    },
    mounted () {
        this.addLoginListener()
    },
    watch: {
        show (latest) {
            if (latest) {
                this.getScrollViewHeight()
            }
        },
        is_block () {
            this.getScrollViewHeight()
        },
        is_peer_blocked() {
            this.getScrollViewHeight()
        },
        is_login: {
            handler (latest, old) {
                if (latest != old && latest) {
                    this.startSession()
                    wx.hideLoading()
                }
            },
            immediate: true
        },
        msgs (latest, past) {
            const pastLen = past.length
            const latestLen = latest.length
            // 首次加载
            if (latestLen && !pastLen) {
                this.show_msg = true
            }
            if (latestLen && pastLen && latestLen > pastLen) {
                if (latest[latestLen - 1].id !== past[pastLen - 1].id) {
                    this.goBottom()
                }
            }
            console.error('msgs change')
            const msgs = latest.filter((msg) => !msg.isSend && !msg.is_read)
            IM.readMsg(this.tim_session_id, msgs)
        }
    },
    computed: {
        show_building_report() {
            const {general_ratings} = this.building
            if (general_ratings) {
                return Object.keys(general_ratings).length > 0
            }
            return false
        },
        open_tools() {
            return this.show_tools || this.show_stickers || this.show_picker
        },
        phone_ask_waiting () {
            const { peer_ask_phone_status } = this.peer_user
            return peer_ask_phone_status === 'waiting' || peer_ask_phone_status === 'none'
        },
        ask_cancel_text () {
            if (this.phone_ask_waiting) {
                return '拒绝'
            }
            if (this.peer_user.peer_ask_phone_status === 'accepted') {
                return '已接受'
            }
            return '已拒绝'
        },
        can_send () {
            if (!this.is_consultant_user) {
                return true
            }
            const msgs = this.msgs.slice(0).reverse()
            // 不能连发 6 条以上
            return msgs.length <= 6 || msgs.slice(0, 6).some(({ isSend }) => !isSend)
        },
        prompt_msg() {
            return this.is_block ? '您已屏蔽对方，将无法收到对方消息！' : this.is_peer_blocked ? '您已被屏蔽，将无法向对方发送消息！' : ''
        },
        consultant_block() {
            return ( this.is_block || this.is_peer_blocked ) && this.is_consult
        },
        normal_block() {
            return ( this.is_block || this.is_peer_blocked ) && !this.is_consult
        },
        show_invite(){
            const { activities } = this.building || {}
            return this.is_consultant_user && activities && activities.indexOf('visit_reservation') > -1
        },
        invite_disable(){
            const last_msg = this.msgs.slice(-1)
            return Boolean(last_msg.length && last_msg[0] && last_msg[0].msgStyle === 'invite')
        }
    },
    beforeDestroy () {
        IM_STORE.remove_chatsMap_watcher(KEY)
        IM.resetChatMapByConversation()
        tasks.forEach((task) => {
            task && clearTimeout(task)
        })
    },
    methods: {
        toggleBottomWrapShow() {
            this.show_bottom_wrap = !this.show_bottom_wrap
        },
        addPriceReport() {
            if (!this.can_send) {
                return
            }
            this.$sendCtmEvtLog('微聊-置业顾问点击发送-楼盘报告')
            const content = (this.building.general_ratings['general'] || '').toString()
            const sendingMsg = IM.creatReportMsg(current_user_data.peer_identifier, content, this.building.id, {
                headimg: current_user_data.headimgurl,
                peerNickName: current_user_data.nickname,
                nickName: current_user_data.peer_nickname,
                peerHeadimg: current_user_data.peer_headimgurl
            })
            IM.sendMsg(sendingMsg)
        },
        chooseSticker(uploaded_path, name) {
            const sendingMsg = IM.creatStickerMsg(current_user_data.peer_identifier, uploaded_path, `[${name}]`, {
                headimg: current_user_data.headimgurl,
                peerNickName: current_user_data.nickname,
                nickName: current_user_data.peer_nickname,
                peerHeadimg: current_user_data.peer_headimgurl
            })
            IM.sendMsg(sendingMsg)
            this.hideStickers()
        },
        getScrollViewHeight () {
            this.$nextTick(() => {
                const top = document.querySelector('#top-section')
                const footer = document.querySelector('#footer')
                if (top && footer) {
                    this.scroll_view_height = `calc(100vh - ${top.offsetHeight}px - ${footer.offsetHeight}px)`
                }
            })
        },
        changeMsg (msg) {
            if (typeof msg === 'string') {
                this.msg = msg
            }
        },
        changeBlock(status) {
            const params = {
                status: status === '屏蔽消息' ? 'blocked' : 'init'
            }
            IM.setBlock(this.tim_session_id, params).then(res => {
                if (res.meta && res.meta.code === 200) {
                    this.is_block = status === '屏蔽消息'
                }
                else if (res.code === 422) {
                    this.showBlockToast(res.error_message)
                    this.is_block = false
                }
            })
        },
        toggleTools () {
            if (this.checkBlocked()) {
                return
            }
            this.show_tools = !this.show_tools
            this.hideStickers()
            this.hidePickerExpression()
        },
        toggleSticker() {
            if (this.checkBlocked()) {
                return
            }
            this.show_stickers = !this.show_stickers
            this.hideTools()
            this.hidePickerExpression()
        },
        hideBuildingCard () {
            this.show_building_card = false
        },
        getUser(){
            return App_User.fetchUser().then((user) => {
                if (user.tag_list[0] == "天府通游客") {
                    wx.redirectTo({
                        url: '/logging_in'
                    })
                    return
                }
                this.is_consultant_user = user.is_consultant
                if (user.is_consultant) {
                    Service.getMyConsultant(false).then(data => this.consultant_id = data.id)
                }
                this.auth_phone_number = Boolean(user.weixin_phone_number)
                this.user_loaded = true
            })
        },
        async startSession () {
            console.error('startSession')
            const { consultant_id, session_id, from, layout_id, auto_send_msg } = this.$route.query
            console.error(consultant_id, session_id, layout_id)
            const params = {
                sessionId: session_id,
                consultantId: consultant_id,
            }
            if (from) {
                params.from = from
            }
            if (layout_id) {
                params.building_image_id = layout_id
            }
            if (auto_send_msg) {
                params.auto_send_msg = auto_send_msg
            }
            await this.getUser()
            const data = await Service.startSession(params)
            this.is_peer_blocked = data.peer_blocked
            this.is_block = data.status === 'blocked'
            if (data.code && data.code === 422) {
                wx.showToast({
                    title: data.error_message,
                    icon: 'none',
                    duration: 3000,
                    mask: true,
                    success () {
                        setTimeout(() => {
                            wx.navigateBack({
                                delta: 1
                            })
                        }, 2000)
                    }
                })
                return
            }
            this.tim_session_id = data.id
            const peer_identifier = data.peer_identifier
            conversationId = `C2C${peer_identifier}`
            const peer_consultant_id = consultant_id || data.peer_consultant_id

            current_user_data.peer_headimgurl = data.peer_headimgurl
            current_user_data.peer_nickname = data.peer_nickname
            current_user_data.peer_identifier = peer_identifier
            current_user_data.nickname = data.nickname
            current_user_data.headimgurl = data.headimgurl

            this.building = data.building || {}

            this.peer_persona = data.peer_persona

            this.rating = data.my_rating

            // 从置业顾问咨询入口进入，且没有发过楼盘卡片的用户才显示
            this.show_building_card = consultant_id && !session_id && !data.sent_building_card

            this.im_user = {
                headimgurl: data.headimgurl,
                original_headimgurl: data.original_headimgurl,
                nickname: data.nickname,
                identifier: data.identifier,
                ask_phone_status: data.ask_phone_status
            }

            this.peer_user = {
                client_name: data.client_name,
                client_description: data.client_description,
                client_mark: data.client_mark,
                peer_headimgurl: data.peer_headimgurl || DEFAULT_HEADIMG,
                original_peer_headimgurl: data.original_peer_headimgurl,
                peer_nickname: data.peer_nickname,
                peer_identifier: data.peer_identifier,
                peer_ask_phone_status: data.peer_ask_phone_status
            }

            IM.getMessages(conversationId)

            const watchMsg = () => {
                IM_STORE.add_chatsMap_watcher(KEY, (chatsMap) => {
                    console.error('chatsMap change', chatsMap)
                    if (chatsMap[conversationId]) {
                        let msgs = chatsMap[conversationId].msgs.reduce((prev, item) => {
                            const is_new_msg = prev.every(({ id }) => {
                                return id !== item.id
                            })
                            if (is_new_msg) {
                                prev.push(item)
                            }
                            return prev
                        }, [])
                        this.msgs = msgs
                        this.loading = false
                        this.show = true
                    }
                })
            }
            if (peer_consultant_id) {
                this.target_is_consultant = true
                this.getConsultant(peer_consultant_id,data.my_rating).then(watchMsg)
            } else {
                watchMsg()
            }
        },
        getConsultant (consultant_id) {
            return Service.getConsultant(consultant_id).then((data) => {
                this.is_consult = true
                const level_key = data.level
                this.consultant = {
                    avatar_mount_url: data.avatar_mount_url || '',
                    id: data.id,
                    name: data.name,
                    building_id: data.building_id,
                    building_name: data.building_name,
                    weixin_name: data.weixin_name,
                    headimg: data.weixin_headimgurl || DEFAULT_HEADIMG,
                    level_key,
                    level: LEVEL_MAP[data.level_key],
                    medal: data.medal
                }
            })
        },
        resetInput () {
            this.changeMsg('')
        },
        checkBlocked () {
            if (this.is_peer_blocked) {
                this.showBlockToast()
                return true
            }
        },
        async sendAudio (msg) {
            const sendingMsg = IM.createAudioMsg(current_user_data.peer_identifier, msg, {
                headimg: current_user_data.headimgurl,
                peerNickName: current_user_data.nickname,
                nickName: current_user_data.peer_nickname,
                peerHeadimg: current_user_data.peer_headimgurl
            })
            IM.sendMsg(sendingMsg)
        },
        async sendMsg (content) {
            if (this.checkBlocked()) {
                this.changeMsg(content)
                return
            }
            if (status.sending) {
                return
            }
            if (!this.can_send) {
                this.resetInput()
                return
            }
            if (!content) {
                return
            }
            this.hideBuildingCard()
            status.sending = true
            const sendingMsg = IM.createTextMsg(current_user_data.peer_identifier, content, {
                headimg: current_user_data.headimgurl,
                peerNickName: current_user_data.nickname,
                nickName: current_user_data.peer_nickname,
                peerHeadimg: current_user_data.peer_headimgurl
            })
            setTimeout(this.resetInput)
            IM.sendMsg(sendingMsg).then(() => {
                this.is_peer_blocked = false
                status.sending = false
            }).catch((err) => {
                if (err.code === 20006) {
                    this.is_peer_blocked = true
                    this.showBlockToast()
                }
                this.changeMsg(content)
                status.sending = false
                errorLog(`SEND_MSG_ERR ${err}`)
            })
        },
        showBlockToast(err="你已被屏蔽") {
            wx.showToast({
                title: err,
                icon: 'none',
                duration: 1000
            })
        },
        selectExpression (content) {
            this.toggleExpression()
            this.sendMsg(content)
        },
        toggleExpression () {
            this.hidePicker()
            this.hideToolsStickers()
            this.show_expression = !this.show_expression
        },
        toggleManage() {
            this.$sendCtmEvtLog('微聊页管理客户点击')
            this.hideToolsStickers()
            this.hideExpression()
            this.show_picker = !this.show_picker
        },
        setPicker(item) {
            const params = {
                mark: item.name
            }
            Service.setTimClientRemark(this.tim_session_id, params)
            this.peer_user.client_mark = item.name
            this.show_picker = false
        },
        async editConfirm(peer_nickname, client_description) {
            let params = {
                client_name: peer_nickname,
                description: client_description
            }
            const data = await Service.setTimClientRemark(this.tim_session_id, params)
            this.peer_user.peer_nickname = data.peer_nickname
            this.peer_user.client_name = data.client_name
        },
        hidePicker() {
            this.show_picker = false
        },
        hideExpression () {
            this.show_expression = false
        },
        hideTools () {
            this.show_tools = false
        },
        hideStickers() {
            this.show_stickers = false
        },
        hidePickerExpression() {
            this.hidePicker()
            this.hideExpression()
        },
        hideToolsStickers() {
            this.hideStickers()
            this.hideTools()
        },
        hideOtherOption () {
            this.hidePickerExpression()
            this.hideToolsStickers()
            this.hideMsgTools()
        },
        goBottom () {
            this.chart_pos = ''
            this.enable_animation = true
            this.$nextTick(() => {
                this.chart_pos = 'msg-btm'
            })
        },
        stopConsult () {
            this.$router.back()
        },
        getMore () {
            if (!this.no_more && !this.loading) {
                this.loading = true
                const last_id = this.msgs.length ? this.msgs[0].id : ''
                this.enable_animation = false
                this.$nextTick(() => {
                    IM.getMessages(conversationId).then(msgs => {
                        wx.hideLoading()
                        console.error(last_id)
                        if (last_id) {
                            this.chart_pos = last_id
                        }
                        this.no_more = !msgs.length
                        this.loading = false
                    })
                })
            }
        },
        previewImg (e) {
            const { preimg } = e.currentTarget.dataset
            const current = preimg.replace(/132$/, 0)
            wx.previewImage({
                current,
                urls: [current]
            })
        },
        previewMsgImg (img) {
            const urls = this.msgs.filter(({ msgStyle }) => msgStyle === 'img').map(({ content }) => content)
            wx.previewImage({
                current: img,
                urls
            })
        },
        chooseImg (uploaded_path) {
            this.sendImg(uploaded_path)
            this.hideTools()
        },
        sendImg (img) {
            const sendingMsg = IM.createImgMsg(current_user_data.peer_identifier, img, {
                headimg: current_user_data.headimgurl,
                peerNickName: current_user_data.nickname,
                nickName: current_user_data.peer_nickname,
                peerHeadimg: current_user_data.peer_headimgurl
            })
            IM.sendMsg(sendingMsg)
        },
        askPhone () {
            this.$set(this.im_user, 'ask_phone_status', 'waiting')
            ChatService.askPhone(this.tim_session_id).then((data) => {
                if (data.code === 422) {
                    this.$set(this.im_user, 'ask_phone_status', 'none')
                }
            })
        },
        handlePhoneAsk (status, callback) {
            if (this.phone_ask_waiting) {
                this.$set(this.peer_user, 'peer_ask_phone_status', status)
                callback()
            }
        },
        rejectPhone () {
            this.handlePhoneAsk('rejected', () => {
                ChatService.rejectPhoneAsk(this.tim_session_id)
            })
        },
        acceptPhone () {
            this.handlePhoneAsk('accepted', () => {
                ChatService.acceptPhoneAsk(this.tim_session_id)
            })
        },
        getPhoneNumber (e) {
            const { iv, encryptedData, errMsg, code } = e.target
            PublicService.postWeixinPhone(iv, encryptedData, errMsg, { code }).then((data) => {
                if (Number(data.code) === 422) {
                    wx.showToast({
                        title: data.error_message,
                        icon: 'none'
                    })
                } else {
                    this.acceptPhone()
                }
            })
        },
        callPhone (phone) {
            this.$showCallModal(() => this.getUserPhoneCall(phone), '置业顾问询问成功——电话拨打')
        },
        getUserPhoneCall (phone_number) {
            PublicService.getPhonePosition({
                sceneable_type: 'Fc::TimSession',
                sceneable_id: this.tim_session_id,
                phone_number
            }).then(({ phone }) => {
                WX_API.makePhoneCall(phone)
            })
        },
        callConsultant () {
            this.$showCallModal(this.getConsultantPhoneCall, '聊天卡片——立即致电置业顾问')
        },
        getConsultantPhoneCall () {
            const { id } = this.consultant
            PublicService.getPhonePosition({
                consultant_id: id
            }).then(({ phone }) => {
                WX_API.makePhoneCall(phone)
                UserLog.callConsultant(id)
            })
        },
        copyPhone (phone) {
            WX_API.setClipboardData(phone)
        },
        sendBuildingCard () {
            console.error(this.building)
            const sendingMsg = IM.createBuildingCardMsg(current_user_data.peer_identifier, this.building, {
                headimg: current_user_data.headimgurl,
                peerNickName: current_user_data.nickname,
                nickName: current_user_data.peer_nickname,
                peerHeadimg: current_user_data.peer_headimgurl
            })
            IM.sendMsg(sendingMsg, false)

        },
        hideBottom () {
            this.hideTools()
            this.hideStickers()
            this.hideExpression()
        },
        async invite(){
            if(this.invite_disable){
                return
            }
            if(!this.invite_click){
                return
            }
            this.invite_click = false
            try{
                const msg = await IM.createInviteCardMsg(current_user_data.peer_identifier,this.building.id)
                await IM.sendMsg(msg, false)
            } catch (err) {
                console.log(err)
            }
            this.invite_click = true
        }
    },
    components: {
        BuildingPriceReport,
        Stickers,
        AqrBuilding,
        ChatJoinGroupCard,
        ClientMarkPicker,
        LocationMsg,
        MsgTools,
        MsgCard,
        MsgSysTip,
        MsgAsk,
        AudioMsg,
        MsgBuildingCard,
        Loading,
        ConsultantCard,
        PeerUser,
        FloatBuildingCard,
        Tools,
        Expression,
        ChatInput,
        LayoutMsg,
        EvaluateDlg,
        InviteCard,
        AuthPhone,
        Invite
    }
}
